import { useEffect, useState } from "react";
import BoxAlert from "../../../../components/boxAlert/index.jsx";
import { saveCompanyNotes } from "../../services/clientNotes.service.js";
import styles from "./css/clientNoteModal.module.css";

export default function ClientNoteModal({
  show,
  companyId,
  initialNotes,
  onClose,
  onSaved,
  onError,
}) {
  const [notesDraft, setNotesDraft] = useState("");
  const [notesSaving, setNotesSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setNotesDraft(initialNotes || "");
    }
  }, [show, initialNotes]);

  const handleClose = () => {
    setNotesDraft(initialNotes || "");
    onClose();
  };

  const handleSave = async () => {
    try {
      if (!companyId) return;

      setNotesSaving(true);

      const savedNotes = await saveCompanyNotes({
        companyId,
        notes: notesDraft,
      });

      onSaved(savedNotes);
      onClose();

    } catch (error) {
      onError(error);

    } finally {
      setNotesSaving(false);
    }
  };

  return (
    <BoxAlert
      show={show}
      showCloseButton={true}
      title={"Editar anotacoes"}
      body={
        <div className={styles.notesModalBody}>
          <textarea
            className={styles.notesInput}
            value={notesDraft}
            maxLength={5000}
            onChange={(event) => setNotesDraft(event.target.value)}
            placeholder={"Digite observacoes internas sobre a empresa"}
          />

          <p className={styles.notesCounter}>{notesDraft.length}/5000</p>

          <div className={styles.actionRow}>
            <button
              type="button"
              className={styles.infoButton}
              onClick={handleClose}
            >
              Cancelar
            </button>

            <button
              type="button"
              className={styles.successButton}
              disabled={notesSaving}
              onClick={handleSave}
            >
              {notesSaving ? "Salvando..." : "Salvar"}
            </button>
          </div>
        </div>
      }
      onClose={handleClose}
    />
  );
}
